import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "clippingpathtype"
    }}>{`ClippingPathType`}</h1>
    <p>{`The type of clipping path to create.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NONE`}</strong>{` = 1852796517`}</p>
      <p parentName="blockquote">{`No clipping path applied.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DETECT_EDGES`}</strong>{` = 1685349735`}</p>
      <p parentName="blockquote">{`The clipping path is based on pixel value threshold and tolerance.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ALPHA_CHANNEL`}</strong>{` = 1634756707`}</p>
      <p parentName="blockquote">{`The clipping path is based on an alpha channel defined for the graphic in a graphics application.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PHOTOSHOP_PATH`}</strong>{` = 1886613620`}</p>
      <p parentName="blockquote">{`The clipping path is defined for the graphic in Photoshop.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`USER_MODIFIED_PATH`}</strong>{` = 1970106484`}</p>
      <p parentName="blockquote">{`(Read-only) The clipping path has been manually edited.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      